(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s99-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => { document.querySelectorAll('.s99-departments[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') document.querySelectorAll('.s99-departments[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      event.promise?.then(({ detail }) => {
        if (!Array.isArray(detail?.items)) return;
        const count = detail.items.reduce((total, item) => total + item.quantity, 0);
        document.querySelectorAll('[data-s99-count]').forEach(el => el.textContent = count);
      }).catch(() => {});
    });
  }).catch(() => {});
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.s99-cart');
    const drawer = document.getElementById('cart-drawer');
    if (link && drawer && typeof drawer.open === 'function' && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      event.preventDefault();
      drawer.open();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
